const iconSize = {
  anchor: new window.google.maps.Point(15, 15),
  scaledSize: new window.google.maps.Size(30, 30),
};

const mapIcons = {
  origin: {
    url: "/icons/origin.png",
    ...iconSize,
  },
  destination: {
    url: "/icons/destination.png",
    ...iconSize,
  },
  boardingPoint: {
    url: "/icons/boarding-point.png",
    ...iconSize,
  },
  intermediateDestination: {
    url: "/icons/intermediate-destination.png",
    ...iconSize,
  },
};

export default mapIcons;
